export default {
  abandonProduct: '放弃商品',
  abandonProductTips:
    '温馨提示：当您确认【放弃商品】后，我们将销毁您的商品，且无法恢复。该商品不会退回给卖家以获得退款。请谨慎操作。',
  finePhotos: '精细拍照',
  ordinaryPhotos: '普通拍照',
  expireText: '包裹即将到期',
  more: '更多',
  timeExpand: '延长时间',
  guaranteeService: '保障服务',
  noNeed: '不需要',
  'i18n-0000002':
    '你的商品已经超期，我们将暂时为您保管 28天，超过该期限后，商品将被视为弃置并作相应处理。',
  'i18n-0000003': '如您需要延长保管期，请您在28天 内尽快购买延长保管期增值服务。',
  'i18n-0000004': '仓储过期时间',
  'i18n-0000016': '商品存储已过期',
  'i18n-0000019': '用户未续费存储服务，默认放弃商品',
  'i18n-0000023': '已完成',
  refundTip: '确认后,仓储费用将退回您的账户。',
  storageEnum: {
    1: '中国1仓',
    2: '中国2仓',
  },
  'i18n-00001':
    '我同意acbuy提供的申报信息修改以符合当地海关要求，提高通关率,若未购买保险,由此产生的通关责任和后果自行承担',
  'i18n-00002': '不同意修改 请按原信息申报，由此产生的通关责任和后果自行承担',
  'i18n-00003': '同意修改',
  'i18n-00004': '不同意修改',
  'i18n-00005': '申报信息修改',
  'i18n-00006': '每条申报信息内容均需要大于25字符,请调整后重新提交',
  'i18n-00007': '重量按实际重与体积重中的较大值估算。任何差额将在称重后 72 小时内多退少补。',
  'i18n-00008': '每条申报信息内容均需要小于{length}字符,请调整后重新提交',
  'i18n-00009':
    '{AI} 还有未支付的增值服务。如需保留，请先完成支付并等待服务完成后再提包；若确认提包，系统将自动取消未支付的增值服务。',
}
